import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '@carm/_utils/string.extensions';
import '@carm/_utils/array.extensions';
import * as dayjs from 'dayjs';
import * as utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(utcPlugin);

import { LicenseManager } from '@ag-grid-enterprise/core';
import { AppInjector } from '@carm/_utils/app.injector';

// eslint-disable-next-line max-len
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-075208}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Deloitte_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Canada_Border_Services_Agency_CARM_Commercial_Portal}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Canada_Border_Services_Agency_CARM_Commercial_Portal}_need_to_be_licensed___{Canada_Border_Services_Agency_CARM_Commercial_Portal}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_April_2026}____[v3]_[01]_MTc3NTk0ODQwMDAwMA==26b811634abf139de16217f586869eb2');

if (environment.production) {

  // window.console.log = () => {}; // remove all console.logs
  window.console.error = () => {}; // remove all console.errors
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then((moduleRef) => {
  AppInjector.setInjector(moduleRef.injector);
})
  .catch((err) => console.error(err));
